import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function ChevronDown({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}

export function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, setIsOpen]);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        className="flex items-center gap-1 text-sm text-smoke hover:text-ink transition"
        onClick={() => setIsOpen((v) => !v)}
      >
        {user?.pseudo ?? user?.email}
        <ChevronDown className="h-3.5 w-3.5" />
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-40 rounded-lg border border-gray-200 bg-white shadow-lg z-50">
          <Link
            to="/profile"
            className="block px-4 py-2.5 text-sm text-ink hover:bg-gray-50 transition"
            onClick={() => setIsOpen(false)}
          >
            Mon profil
          </Link>
          {user?.role === "admin" && (
            <Link
              to="/admin"
              className="block px-4 py-2.5 text-sm text-ember hover:bg-gray-50 transition sm:hidden"
              onClick={() => setIsOpen(false)}
            >
              Admin
            </Link>
          )}
          <button
            type="button"
            className="block w-full px-4 py-2.5 text-left text-sm text-smoke hover:bg-gray-50 transition"
            onClick={() => {
              setIsOpen(false);
              void logout().then(() => navigate("/login"));
            }}
          >
            Quitter
          </button>
        </div>
      )}
    </div>
  );
}
